import React from "react";
import { Link } from "react-router-dom";
import { Trash } from "react-feather";
import config from "/app/src/config.js";

const isMobileOnly = config.mbl_version;

export default function BrandSimple({
    deleteModeActive = false,
    ...props
}) {

    /*
     * ============================================================
     * DELETE MODE
     * ============================================================
     *
     * Mostramos el modo eliminar con el mismo estilo
     * que las cabeceras de los tipos de SeYe:
     *
     *          icono
     *         Eliminar
     *
     * No añadimos Link porque pulsar sobre el título
     * no debe provocar ninguna navegación.
     */
    if (deleteModeActive) {

        return (
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#6e6b7b",
                    lineHeight: "1.1"
                }}
            >

                <Trash
                    size={20}
                    style={{
                        marginBottom: "3px"
                    }}
                />

                <span
                    style={{
                        fontSize: "14px",
                        fontWeight: "400"
                    }}
                >
                    Eliminar
                </span>

            </div>
        );
    }


    /*
     * ============================================================
     * NORMAL MODE
     * ============================================================
     */

    // Default style for desktop
    let style = {
        fontSize: "3.5em"
    };


    // Style for smartphone
    if (isMobileOnly) {

        style = {
            ...style,
            fontSize: "2em"
        };
    }


    // Get simple brand
    let brand = (
        <div
            className="brand-text-black"
            style={style}
        >
            Seye

            {/*
            <sub
                style={{
                    fontSize: "10px"
                }}
            >
                Alpha
            </sub>
            */}

        </div>
    );


    /*
     * If caller has destination,
     * set link on logo.
     */
    if (props.to) {

        brand = (
            <Link to={props.to}>
                {brand}
            </Link>
        );
    }


    return (
        <>
            {brand}
        </>
    );
}